import { type Channel, ProductType } from "@/api_client";
import { DogEntryForm } from "@/components/products/dog/entry/DogEntryForm";
import { ProductContainer } from "@/components/shared/productContainer/ProductContainer";
import type { Locales } from "@/graphql/generated";
import { useEntryContentExternal } from "@/services/cms/tanstackQuery/hooks/useEntryContentExternal";
import { useEntryForWebComponents } from "../hooks/useEntryForWebComponents";

type DogEntryProps = {
  backendHost?: string;
  appPathPrefix?: string;
  skipCart: boolean;
  channel?: Channel;
  language?: string;
};

export default function DogEntry({
  backendHost,
  appPathPrefix,
  skipCart,
  channel,
  language,
}: Readonly<DogEntryProps>) {
  const { isLoading, isSubmitting, submitEntryHandler, policyHolder, user } =
    useEntryForWebComponents({
      productType: "dog",
      backendHost,
      appPathPrefix,
      skipCart,
      channel,
      language,
    });

  const { data: content, isLoading: isLoadingContent } =
    useEntryContentExternal({
      product: ProductType.DOG,
      language: language as Locales,
      appPathPrefix,
    });

  if (isLoading || isLoadingContent) return <ProductContainer.Loader />;

  return (
    <DogEntryForm
      externalIsLoading={isSubmitting}
      externalSubmitHandler={submitEntryHandler}
      externalPolicyHolder={policyHolder}
      externalUser={user}
      externalContent={content}
    />
  );
}
